// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './DiamondIcon.style';

export class DiamondIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <div className="DiamondIcon">
                <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M61.2434 24.5915C60.4307 23.3431 59.6145 22.0948 58.8001 20.8465C57.2549 18.4838 55.6584 16.0397 54.1047 13.6244C53.3961 12.5253 52.4895 12.0352 51.1662 12.0352H51.1355C47.2084 12.0572 43.2182 12.0521 39.3577 12.0487C36.385 12.047 33.4141 12.047 30.4415 12.0487C26.5435 12.0521 22.5139 12.0555 18.5493 12.0352H18.5237C17.2243 12.0352 16.3314 12.5185 15.6347 13.5973C14.0895 15.9888 12.5033 18.4075 10.97 20.7464C10.1266 22.0337 9.2814 23.3211 8.43964 24.6101C7.52105 26.0196 7.60471 27.1085 8.73332 28.3687C18.3564 39.1102 25.7256 47.3262 32.6253 55.0096C33.3083 55.7711 34.0749 56.1731 34.8415 56.1731C35.6082 56.1731 36.3885 55.7643 37.0817 54.9926C44.1982 47.0684 51.7894 38.6048 60.9753 28.3518C62.092 27.1051 62.1705 26.0162 61.2434 24.5915ZM50.9784 13.7889L43.686 24.9867L36.3936 13.7889H50.9784ZM42.1134 25.6838H27.585L34.8467 14.5301L42.1134 25.6838ZM33.2963 13.7906L26.0261 24.9612L18.7456 13.7906H33.2963ZM17.1338 14.425L24.4689 25.6872H9.76802L17.1338 14.425ZM31.9184 51.6835L10.1795 27.4393H25.3909L32.7704 51.2374L31.9184 51.6835ZM35.3281 50.6336L34.4147 50.7829L27.1735 27.4376H42.5215L35.3281 50.6336ZM37.7732 51.6835L36.928 51.2137L44.3041 27.4274H59.5223L37.7732 51.6835ZM45.279 25.66L52.5902 14.4284L59.9099 25.66H45.279Z" fill="#1E1E1E" />
                </svg>
            </div>
        );
    }
}

export default DiamondIcon;
